import { useAuth } from '../context/AuthContext';
import { useAuthModalContext } from '../context/AuthModalContext';

import { useInputValue, useMessageSubmit } from './LandingPageHelpers';

export const useLandingPageState = () => {
  const inputState = useInputValue();
  const authModal = useAuthModalContext();
  const auth = useAuth();
  const messageSubmit = useMessageSubmit();

  return { inputState, authModal, auth, messageSubmit };
};
